module.exports = __webpack_public_path__ + "static/img/feature-bg.37b04ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature-bg.png
// module id = Xhqm
// module chunks = 0